import { Box, Button, Typography } from '@mui/material';
import styles from './BasePageStructure.module.css';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

export interface IBasePageStructure {
  title: string;
  children?: React.ReactNode;
  additionalHeaderMenu?: JSX.Element;
  showBackButton?: boolean;
}

const BasePageStructure: React.FC<IBasePageStructure> = ({ title, children, additionalHeaderMenu, showBackButton }) => {
  return (
    <Box className={styles.container}>
      <Box className={styles.headerContainer}>
        <Button
          variant="text"
          className={styles.backButton}
          onClick={() => window.history.back()}
          style={{ display: showBackButton ? 'block' : 'none' }}
        >
          <KeyboardBackspaceIcon />
        </Button>
        <Typography variant="h3" className={styles.title}>
          {title}
        </Typography>
        <Box>{additionalHeaderMenu}</Box>
      </Box>
      {children}
    </Box>
  );
};

export default BasePageStructure;
